module.exports = {
	"spreadsheetId": "2",
	"properties": {
		"title": "Sanchez Fixture Schedule"
	},
	"sheets": [
		{
			"properties": {
				"sheetId": 293666632,
				"title": "School",
				"index": 0,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 502,
					"columnCount": 12,
					"frozenRowCount": 1,
					"frozenColumnCount": 1
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{},
								{},
								{
									"formattedValue": "Monday"
								},
								{},
								{
									"formattedValue": "Tuesday"
								},
								{},
								{
									"formattedValue": "Wednesday"
								},
								{},
								{
									"formattedValue": "Thursday"
								},
								{},
								{
									"formattedValue": "Friday"
								},
								{}
							]
						},
						{
							"values": [
								{},
								{
									"formattedValue": "teacher_id"
								},
								{
									"formattedValue": "meeting_id"
								},
								{
									"formattedValue": "section_id"
								},
								{
									"formattedValue": "meeting_id"
								},
								{
									"formattedValue": "section_id"
								},
								{
									"formattedValue": "meeting_id"
								},
								{
									"formattedValue": "section_id"
								},
								{
									"formattedValue": "meeting_id"
								},
								{
									"formattedValue": "section_id"
								},
								{
									"formattedValue": "meeting_id"
								},
								{
									"formattedValue": "section_id"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KA"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								},
								{},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KB"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "KC"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACh"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "1C"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "2B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "VAPA"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "VAPA"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "VAPA"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "VAPA"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00-12:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15-12:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "3B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Coteach"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "4B"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "5A"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PE KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "PE KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PE 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PE 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PE 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PE 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "PE 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": " "
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "PE 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "PE 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "VAPA 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "VAPA 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "VAPA 2B"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "VAPA 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "VAPA 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "VAPA 3A"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KC"
								},
								{},
								{
									"formattedValue": "VAPA 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "VAPA 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "VAPA 5A"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "VAPA 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "VAPA 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "VAPA 3B/VAPA 2A"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "VAPA 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "VAPA 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "VAPA 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "VAPA 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "VAPA 4B"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "COTEACH KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "COTEACH KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "COTEACH KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "COTEACH KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "COTEACH 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Specials 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Specials 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "Specials KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PW 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW 1C"
								},
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "PW 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "PW 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PW 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "PW 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "PW 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PW 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "PW KC"
								},
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "PW 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Specials 2B"
								},
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "Specials 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "prep"
								},
								{},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "COTEACH 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 1B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Specials 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Specials 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Specials 4A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "COTEACH 1A"
								},
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "Lunch"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "COTEACH KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Specials 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Specials 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Specials 3A"
								},
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Specials KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "COTEACH 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{}
							]
						},
						{
							"values": [
								{
									"formattedValue": "7:45-8:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:00-8:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:15-8:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:30 - 8:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "G 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "8:45-9:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G 1B"
								},
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "G 2A"
								},
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:00-9:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:15 - 9:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:30-9:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "9:45-10:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:00 - 10:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "Rec"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:15 - 10:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "G 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "G 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:30 - 10:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "G 4B"
								},
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "G 5A"
								},
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "10:45 - 11:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G KA"
								},
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:00 - 11:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:15 - 11:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:30 - 11:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "11:45 - 12:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:00 - 12:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:15 - 12:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "prep"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:30-12:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "prep"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "12:45-1:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:00 - 1:15"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:15 - 1:30"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:30 - 1:45"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "G 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "Lunch"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1:45-2:00"
								},
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "G KB"
								},
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "G 3B"
								},
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "PD"
								},
								{},
								{
									"formattedValue": "0"
								},
								{
									"formattedValue": "0"
								}
							]
						}
					]
				}
			]
		},
		{
			"properties": {
				"sheetId": 1558634518,
				"title": "Teachers",
				"index": 1,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 1000,
					"columnCount": 27
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "id"
								},
								{
									"formattedValue": "name"
								},
								{
									"formattedValue": "group"
								},
								{
									"formattedValue": "group_id"
								},
								{
									"formattedValue": "tags"
								},
								{
									"formattedValue": "fte"
								},
								{
									"formattedValue": "prep_teachers"
								},
								{
									"formattedValue": "release_teachers"
								},
								{
									"formattedValue": "unavailable"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KA"
								},
								{
									"formattedValue": "Kinder A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "Kindergarten"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "KA,KB,KC"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "3"
								},
								{},
								{
									"formattedValue": "FALSE"
								},
								{},
								{},
								{
									"formattedValue": "Thursday"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KB"
								},
								{
									"formattedValue": "Kinder B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "Kindergarten"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "KA,KB,KC"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "KC"
								},
								{
									"formattedValue": "Kinder C"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "Kindergarten"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "KA,KB,KC"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1A"
								},
								{
									"formattedValue": "1st A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "1st grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "1A,1B,1C"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "V"
								},
								{
									"formattedValue": "VAPA"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "3"
								},
								{},
								{
									"formattedValue": "FALSE"
								},
								{},
								{},
								{
									"formattedValue": "Wednesday,Thursday,Friday"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Sci"
								},
								{
									"formattedValue": "Science"
								},
								{
									"formattedValue": "Enrichment"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "TRUE"
								},
								{},
								{},
								{
									"formattedValue": "Monday,Friday"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1B"
								},
								{
									"formattedValue": "1st B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "1st grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "1A,1B,1C"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Garden"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "3"
								},
								{},
								{
									"formattedValue": "FALSE"
								},
								{},
								{},
								{
									"formattedValue": "Friday"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Playworks"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "3"
								},
								{},
								{
									"formattedValue": "FALSE"
								},
								{},
								{},
								{
									"formattedValue": "Friday"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Tech"
								},
								{
									"formattedValue": "Technology"
								},
								{
									"formattedValue": "Enrichment"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "1C"
								},
								{
									"formattedValue": "1st C"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "1st grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "1A,1B,1C"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Lib"
								},
								{
									"formattedValue": "Library"
								},
								{
									"formattedValue": "Enrichment"
								},
								{
									"formattedValue": "2"
								},
								{},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "2A"
								},
								{
									"formattedValue": "2nd A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "2nd grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "2A,2B"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "2B"
								},
								{
									"formattedValue": "2nd B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "2nd grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "2A,2B"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "3A"
								},
								{
									"formattedValue": "3rd A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "3rd grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "3A,3B"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "3B"
								},
								{
									"formattedValue": "3rd B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "3rd grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "3A,3B"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "4A"
								},
								{
									"formattedValue": "4th A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "4th grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "4A,4B,5A"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "4B"
								},
								{
									"formattedValue": "4th B"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "4th grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "4A,4B,5A"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "5A"
								},
								{
									"formattedValue": "5th A"
								},
								{
									"formattedValue": "Classroom"
								},
								{
									"formattedValue": "1"
								},
								{
									"formattedValue": "4th grade"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "4A,4B,5A"
								},
								{
									"formattedValue": "V,Sci,Tech,Lib"
								}
							]
						}
					]
				}
			]
		},
		{
			"properties": {
				"sheetId": 1120187879,
				"title": "Meetings",
				"index": 2,
				"sheetType": "GRID",
				"gridProperties": {
					"rowCount": 997,
					"columnCount": 26
				}
			},
			"data": [
				{
					"rowData": [
						{
							"values": [
								{
									"formattedValue": "id"
								},
								{
									"formattedValue": "name"
								},
								{
									"formattedValue": "type"
								},
								{
									"formattedValue": "core"
								},
								{
									"formattedValue": "instructional"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "Intake"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "ELD"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "PE"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "Ins"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "TRUE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Rec"
								},
								{
									"formattedValue": "Recess"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PW"
								},
								{
									"formattedValue": "Playworks"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "G"
								},
								{
									"formattedValue": "Garden"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "Lunch"
								},
								{
									"formattedValue": "Break"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "VAPA"
								},
								{
									"formattedValue": "VAPA"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "COTEACH"
								},
								{
									"formattedValue": "Blended"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Specials"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Duty"
								},
								{
									"formattedValue": "Duty"
								},
								{
									"formattedValue": "Duty"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "Prep"
								},
								{
									"formattedValue": "Prep"
								},
								{},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "PD"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "FALSE"
								}
							]
						},
						{
							"values": [
								{
									"formattedValue": "PWG"
								},
								{
									"formattedValue": "Playworks/Garden"
								},
								{
									"formattedValue": "Instructional"
								},
								{
									"formattedValue": "FALSE"
								},
								{
									"formattedValue": "TRUE"
								}
							]
						}
					]
				}
			]
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/clients/mock/fixtures/sheets/2.json
 ** module id = 299
 ** module chunks = 0
 **/